export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="M21 18.1a.9.9 0 0 1 0 1.8H3a.9.9 0 1 1 0-1.8h18Zm0-7a.9.9 0 0 1 0 1.8H3a.9.9 0 1 1 0-1.8h18Zm0-7a.9.9 0 0 1 0 1.8H3a.9.9 0 1 1 0-1.8h18Z"/>
</svg>
`;
